import { useEffect } from 'react';
import { getUsageTracker } from '../../utils/usage-tracker/index';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMetadata } from 'developer-docs-shared-components/hooks/useMetadata';
import Card from 'developer-docs-mdx-components/components/Card';
import I18n from 'I18n';
import { EERIE } from 'HubStyleTokens/colors';
import UIAlert from 'UIComponents/alert/UIAlert';
import H2 from 'UIComponents/elements/headings/H2';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIMedia from 'UIComponents/layout/UIMedia';
import H1 from 'developer-docs-shared-components/components/PublicH1';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { Illustration, Media, MediaBody, Right } from './sharedStyledComponents';
import { apiGuidesNavConfig } from '../../config/nav/guides/apiGuides';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function ApiLandingPage() {
  useMetadata({
    title: I18n.text('developer-docs-ui.htmlTitles.apiReferenceOverview'),
    description: I18n.text('developer-docs-ui.metaDescriptions.apiReferenceOverview'),
    isContentLoaded: true
  });

  // If there are named exports as well, *.default needs to be used

  useEffect(() => {
    getUsageTracker().track('pageView', {
      screen: 'apiLandingPage',
      subscreen: 'apiLandingPage'
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(H1, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.apiLandingPage.header"
      })
    }), /*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.apiLandingPage.intro"
      })
    }), /*#__PURE__*/_jsx(MediaBody, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.apiLandingPage.welcome"
      })
    }), /*#__PURE__*/_jsx(UIAlert, {
      className: "m-top-6",
      type: "tip",
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.apiLandingPage.versioningAlertTitleText"
      }),
      use: "inline",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.apiLandingPage.versioningAlertBody"
      })
    }), /*#__PURE__*/_jsx(Card, {
      children: /*#__PURE__*/_jsxs(Media, {
        align: "center",
        children: [/*#__PURE__*/_jsxs(MediaBody, {
          children: [/*#__PURE__*/_jsx(H2, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "developer-docs-ui.apiLandingPage.benefits"
            })
          }), /*#__PURE__*/_jsxs("ul", {
            children: [/*#__PURE__*/_jsx("li", {
              className: "m-bottom-4",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "developer-docs-ui.apiLandingPage.benefitBullet1"
              })
            }), /*#__PURE__*/_jsx("li", {
              className: "m-bottom-4",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "developer-docs-ui.apiLandingPage.benefitBullet2"
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "developer-docs-ui.apiLandingPage.benefitBullet3"
              })
            })]
          })]
        }), /*#__PURE__*/_jsx(Right, {
          children: /*#__PURE__*/_jsx(Illustration, {
            name: "api"
          })
        })]
      })
    }), /*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.apiLandingPage.guides.header"
      })
    }), /*#__PURE__*/_jsxs(MediaBody, {
      className: "m-bottom-12",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.apiLandingPage.guides.description"
      }), /*#__PURE__*/_jsxs(UIMedia, {
        align: "center",
        className: "m-top-8",
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "bulb",
          size: "medium",
          className: "m-right-3",
          color: EERIE
        }), /*#__PURE__*/_jsx(UIRouterLink, {
          to: apiGuidesNavConfig().commonPath,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-docs-ui.apiLandingPage.guides.link"
          })
        })]
      })]
    })]
  });
}
export default ApiLandingPage;